import { Component } from "@angular/core";

@Component({
  standalone: false,
  template:''
})
export class EmptyComponent {
  
}